module.exports = __webpack_public_path__ + "img/file-csv-white.5dbd8eb3.png";